import "@/index.css";
import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { Layout } from "@/components/site/Layout";

import Home from "@/pages/Home";
import TatiSofia from "@/pages/TatiSofia";
import Articole from "@/pages/Articole";
import ArticolDetail from "@/pages/ArticolDetail";
import VideoHub from "@/pages/VideoHub";
import VideoDetail from "@/pages/VideoDetail";
import SpunePovestea from "@/pages/SpunePovestea";
import Comunitate from "@/pages/Comunitate";
import StoryDetail from "@/pages/StoryDetail";
import Ajutor from "@/pages/Ajutor";
import Quiz from "@/pages/Quiz";
import Petitii from "@/pages/Petitii";
import PetitieDetail from "@/pages/PetitieDetail";
import Legislatie from "@/pages/Legislatie";
import Institutii from "@/pages/Institutii";
import Shop from "@/pages/Shop";
import Booking from "@/pages/Booking";
import Doneaza from "@/pages/Doneaza";
import Semnaleaza from "@/pages/Semnaleaza";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import ChatHelper from "@/pages/ChatHelper";
import Intalniri from "@/pages/Intalniri";
import IntalnireDetail from "@/pages/IntalnireDetail";
import ScanAP from "@/pages/ScanAP";
import ScanAPDashboard from "@/pages/ScanAPDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Router() {
  const { hash } = useLocation();
  // OAuth callback synchronous check
  if (hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/tati-sofia" element={<TatiSofia />} />
      <Route path="/articole" element={<Articole />} />
      <Route path="/articole/:slug" element={<ArticolDetail />} />
      <Route path="/video" element={<VideoHub />} />
      <Route path="/video/:id" element={<VideoDetail />} />
      <Route path="/spune-povestea" element={<SpunePovestea />} />
      <Route path="/comunitate" element={<Comunitate />} />
      <Route path="/comunitate/:id" element={<StoryDetail />} />
      <Route path="/ajutor" element={<Ajutor />} />
      <Route path="/test" element={<Quiz />} />
      <Route path="/petitii" element={<Petitii />} />
      <Route path="/petitii/:slug" element={<PetitieDetail />} />
      <Route path="/legislatie" element={<Legislatie />} />
      <Route path="/institutii" element={<Institutii />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/shop/success" element={<PaymentSuccess type="shop" />} />
      <Route path="/programare" element={<Booking />} />
      <Route path="/programare/success" element={<PaymentSuccess type="booking" />} />
      <Route path="/doneaza" element={<Doneaza />} />
      <Route path="/doneaza/success" element={<PaymentSuccess type="donation" />} />
      <Route path="/semnaleaza" element={<Semnaleaza />} />
      <Route path="/autentificare" element={<Auth />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/profil" element={<Profile />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/asistent" element={<ChatHelper />} />
      <Route path="/intalniri" element={<Intalniri />} />
      <Route path="/intalniri/:slug" element={<IntalnireDetail />} />
      <Route path="/scan-ap" element={<ScanAP />} />
      <Route path="/scan-ap/:id/dashboard" element={<ScanAPDashboard />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ScrollToTop />
        <Layout>
          <Router />
        </Layout>
      </AuthProvider>
    </BrowserRouter>
  );
}
